import { RootState } from "Store";

export const selectFeatureGroupList = (state: RootState) =>
  state.FeatureGroupReducer.featureGroupList;

export const selectCurrentFeatureGroup = (state: RootState) =>
  state.FeatureGroupReducer.currentFeatureGroup;

export const selectIsFeatureGroupModalOpen = (state: RootState) =>
  state.FeatureGroupReducer.isModalOpen;

export const selectIsFeatureGroupLoading = (state: RootState) =>
  state.FeatureGroupReducer.isLoading;

export const selectFeatureGroupById = (id: string) => (state: RootState) =>
  state.FeatureGroupReducer.featureGroupList.find((group: any) => group.id === id);

export const selectActiveFeatureGroups = (state: RootState) =>
  state.FeatureGroupReducer.featureGroupList.filter((group: any) => group.isActive);
